// @flow

// Apply filter queries to the blog loop.

import { delegate } from '../utils/tools';

let loopFilters: null | HTMLFormElement = null;
let multimedia: null | HTMLInputElement = null;
let multimediaHidden: null | HTMLInputElement = null;

function submitFormOnChange(event) {
	if (!loopFilters || !multimediaHidden) {
		return;
	}

	let shouldChangeValue =
		event.delegateTarget === multimedia && multimediaHidden.value === '1';

	if (shouldChangeValue) {
		multimediaHidden.value = '0';
	}

	loopFilters.submit();
}

function bindEvents() {
	if (!loopFilters) {
		return;
	}

	delegate(
		loopFilters,
		'[data-js="loop-filter-select"], [data-js="loop-filter-multimedia"]',
		'change',
		submitFormOnChange
	);
}

export default function init() {
	loopFilters = (document.querySelector('[data-js=loop-filters]'): any);
	if (!loopFilters) {
		return;
	}

	multimedia = (document.querySelector(
		'[data-js=loop-filter-multimedia]'
	): any);
	multimediaHidden = (document.querySelector(
		'[data-js=multimedia-hidden]'
	): any);

	bindEvents();
}
